import React, { useState, useEffect } from "react";
import { getTheRoundTimeRemaining } from '../utils/functions'

const SECONDS_IN_A_DAY = 86400; // 24 hours * 60 minutes * 60 seconds
const SECONDS_IN_AN_HOUR = 3600; // 60 minutes * 60 seconds
const useCountdown = (func) => {


  const localTimeRef = React.useRef(0);
  const [days, setdays] = useState(0);
  const [minutes, setminutes] = useState(0);
  const [hours, sethours] = useState(0);
  const [seconds, setseconds] = useState(0);
  const [formattedTimeLeft, setFormattedTimeLeft] = useState("");

  const convertTimeToFormatted = (timeRemainingParsed) => {
    //  const newTimeLeft = Number(timeRemainingParsed);
      //const remainingTime = new Date(newTimeLeft * 1000);
      const SECONDS_IN_A_DAY = 86400; 

      const newTimeLeft = Number(timeRemainingParsed);
      
      // Calculate days
      const days = Math.floor(newTimeLeft / SECONDS_IN_A_DAY);
      const timeLeftAfterDaysInSeconds = newTimeLeft % SECONDS_IN_A_DAY;
      
      // Convert the remaining time into a Date object
      const remainingTime = new Date(timeLeftAfterDaysInSeconds * 1000);
      
      const hours = remainingTime.getUTCHours();
      const minutes = remainingTime.getUTCMinutes();
      const seconds = remainingTime.getUTCSeconds();
      
      const formattedTime = `${days} days, ${hours} hours, ${minutes} mins, ${seconds} secs`; setFormattedTimeLeft(formattedTime);

      setdays(days)
      sethours(hours)
      setminutes(minutes)
      setseconds(seconds)
    };
 

    useEffect(() => {
      const localTimer = async () => {
        // if doesn't exist yet, grab latest from contract!
        if (!localTimeRef.current) {
          let time;
          if (func=='auction'){
          time = await getTheRoundTimeRemaining()
          const _rawTimeRemaining = time;
          
          localTimeRef.current = parseInt(_rawTimeRemaining);
        }        }
        if (!localTimeRef.current) {
          localTimeRef.current = 0;
        } else {
          // decrement by a second
          localTimeRef.current = localTimeRef.current - 1;
          convertTimeToFormatted(localTimeRef.current);
        }
      };
      // run local every second
      const interval = setInterval(localTimer, 1000);
      return () => clearInterval(interval);
    }, []);

    const daysMatch = formattedTimeLeft.match(/(\d+)\s*days?/);
    const hoursMatch = formattedTimeLeft.match(/(\d+)\s*hours?/);
    const minutesMatch = formattedTimeLeft.match(/(\d+)\s*mins?/);
    const secondsMatch = formattedTimeLeft.match(/(\d+)\s*secs?/);
    
    const daysis = daysMatch ? parseInt(daysMatch[1], 10) : 0;
    const hoursis = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
    const minutesis = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;
    const secondsis = secondsMatch ? parseInt(secondsMatch[1], 10) : 0;

  return [formattedTimeLeft,daysis,hoursis,minutesis,secondsis];

};

export default useCountdown;
